import { HeaderProps } from './Types'
import { getIcon } from './utils'
import Styles from './ShareSheet.module.scss'

export const Header = ({ asset }: HeaderProps) => {
  if (!asset) return <></>

  const { type, header_emoji, title, channel } = asset

  return (
    <div className={Styles.header}>
      <div className={Styles.titleRow}>
        <span className={Styles.icon}>{getIcon(type, header_emoji, true, channel)}</span>
        <span className={Styles.title}>{title}</span>
      </div>
    </div>
  )
}
